<template>
  <WizardContainer
    :width="isDatapeopleAnywhere ? '380px' : '792px'"
    :height="isDatapeopleAnywhere ? 'auto' : '624px'"
  >
    <WizardContent>
      <h4
        :class="[
          'terms-header',
          isDatapeopleAnywhere ? 'mb-4' : ['mt-6', 'mb-8']]"
      >
        Datapeople's Terms of Service
      </h4>
      <div class="terms-and-conditions mb-4">
        <p>
          <b>Terms and Conditions</b><br>
          <b>Last updated: May 22, 2018</b><br><br>
          <!-- eslint-disable-next-line vue/max-len -->
          Please read these Terms and Conditions (“Terms”, “Terms and Conditions”) carefully before using the Datapeople.io website (the “Service”) operated by TAPWAGE INC (“us”, “we”, or “our”).<br><br>
          <!-- eslint-disable-next-line vue/max-len -->
          Your access to and use of the Service is conditioned upon your acceptance of and compliance with these Terms. These Terms apply to all visitors, users and others who wish to access or use the Service.<br><br>
          <!-- eslint-disable-next-line vue/max-len -->
          By accessing or using the Service you agree to be bound by these Terms. If you disagree with any part of the terms then you do not have permission to access the Service.<br><br>

          <b>Communications</b><br>
          <!-- eslint-disable-next-line vue/max-len -->
          By creating an Account on our service, you agree to subscribe to newsletters, marketing or promotional materials and other information we may send. However, you may opt out of receiving any, or all, of these communications from us by following the unsubscribe link or instructions provided in any email we send.<br><br>

          <b>Subscriptions</b><br>
          <!-- eslint-disable-next-line vue/max-len -->
          Some parts of the Service are billed on a subscription basis (“Subscription(s)”). You will be billed in advance on a recurring and periodic basis (“Billing Cycle”). Billing cycles are set either on a monthly or annual basis, depending on the type of subscription plan you select when purchasing a Subscription.<br><br>
          <!-- eslint-disable-next-line vue/max-len -->
          At the end of each Billing Cycle, your Subscription will automatically renew under the exact same conditions unless you cancel it or TAPWAGE INC cancels it. You may cancel your Subscription renewal either through your online account management page or by contacting TAPWAGE INC customer support team.<br><br>
          <!-- eslint-disable-next-line vue/max-len -->
          A valid payment method, including credit card, is required to process the payment for your Subscription. You shall provide TAPWAGE INC with accurate and complete billing information including full name, address, state, zip code, telephone number, and a valid payment method information. By submitting such payment information, you automatically authorize TAPWAGE INC to charge all Subscription fees incurred through your account to any such payment instruments.<br><br>
          <!-- eslint-disable-next-line vue/max-len -->
          Should automatic billing fail to occur for any reason, TAPWAGE INC will issue an electronic invoice indicating that you must proceed manually, within a certain deadline date, with the full payment corresponding to the billing period as indicated on the invoice.<br><br>

          <b>Free Trial</b><br>
          <!-- eslint-disable-next-line vue/max-len -->
          TAPWAGE INC may, at its sole discretion, offer a Subscription with a free trial for a limited period of time (“Free Trial”).<br><br>

          <!-- eslint-disable-next-line vue/max-len -->
          You may be required to enter your billing information in order to sign up for the Free Trial.<br><br>
          <!-- eslint-disable-next-line vue/max-len -->
          If you do enter your billing information when signing up for the Free Trial, you will not be charged by TAPWAGE INC until the Free Trial has expired. On the last day of the Free Trial period, unless you cancelled your Subscription, you will be automatically charged the applicable Subscription fees for the type of Subscription you have selected.<br><br>
          <!-- eslint-disable-next-line vue/max-len -->
          At any time and without notice, TAPWAGE INC reserves the right to (i) modify the terms and conditions of the Free Trial offer, or (ii) cancel such Free Trial offer.<br><br>

          <b>Fee Changes</b><br>
          <!-- eslint-disable-next-line vue/max-len -->
          TAPWAGE INC, in its sole discretion and at any time, may modify the Subscription fees for the Subscriptions. Any Subscription fee change will become effective at the end of the then-current Billing Cycle.<br><br>
          <!-- eslint-disable-next-line vue/max-len -->
          TAPWAGE INC will provide you with a reasonable prior notice of any change in Subscription fees to give you an opportunity to terminate your Subscription before such change becomes effective.<br><br>
          <!-- eslint-disable-next-line vue/max-len -->
          Your continued use of the Service after the Subscription fee change comes into effect constitutes your agreement to pay the modified Subscription fee amount.<br><br>

          <b>Refunds</b><br>
          <!-- eslint-disable-next-line vue/max-len -->
          Certain refund requests for Subscriptions may be considered by TAPWAGE INC on a case-by-case basis and granted in sole discretion of TAPWAGE INC.<br><br>

          <b>Content</b><br>
          <!-- eslint-disable-next-line vue/max-len -->
          Our Service allows you to post, link, store, share and otherwise make available certain information, text, graphics, videos, or other material (“Content”). You are responsible for the Content that you post on or through the Service, including its legality, reliability, and appropriateness.<br><br>
          <!-- eslint-disable-next-line vue/max-len -->
          By posting Content on or through the Service, You represent and warrant that: (i) the Content is yours (you own it) and/or you have the right to use it and the right to grant us the rights and license as provided in these Terms, and (ii) that the posting of your Content on or through the Service does not violate the privacy rights, publicity rights, copyrights, contract rights or any other rights of any person or entity. We reserve the right to terminate the account of anyone found to be infringing on a copyright.<br><br>
          <!-- eslint-disable-next-line vue/max-len -->
          You retain any and all of your rights to any Content you submit, post or display on or through the Service and you are responsible for protecting those rights. We take no responsibility and assume no liability for Content you or any third party posts on or through the Service. However, by posting Content using the Service you grant us the right and license to use, modify, perform, display, reproduce, and distribute such Content on and through the Service.<br><br>
          <!-- eslint-disable-next-line vue/max-len -->
          TAPWAGE INC has the right but not the obligation to monitor and edit all Content provided by users.<br><br>
          <!-- eslint-disable-next-line vue/max-len -->
          In addition, Content found on or through this Service are the property of TAPWAGE INC or used with permission. You may not distribute, modify, transmit, reuse, download, repost, copy, or use said Content, whether in whole or in part, for commercial purposes or for personal gain, without express advance written permission from us.<br><br>

          <b>Accounts</b><br>
          <!-- eslint-disable-next-line vue/max-len -->
          When you create an account with us, you guarantee that you are above the age of 18, and that the information you provide us is accurate, complete, and current at all times. Inaccurate, incomplete, or obsolete information may result in the immediate termination of your account on the Service.<br><br>
          <!-- eslint-disable-next-line vue/max-len -->
          You are responsible for maintaining the confidentiality of your account and password, including but not limited to the restriction of access to your computer and/or account. You agree to accept responsibility for any and all activities or actions that occur under your account and/or password, whether your password is with our Service or a third-party service. You must notify us immediately upon becoming aware of any breach of security or unauthorized use of your account.<br><br>

          <b>Intellectual Property</b><br>
          <!-- eslint-disable-next-line vue/max-len -->
          The Service and its original content (excluding Content provided by users), features and functionality are and will remain the exclusive property of TAPWAGE INC and its licensors. The Service is protected by copyright, trademark, and other laws of both the United States and foreign countries. Our trademarks and trade dress may not be used in connection with any product or service without the prior written consent of TAPWAGE INC.<br><br>

          <b>Links To Other Web Sites</b><br>
          <!-- eslint-disable-next-line vue/max-len -->
          Our Service may contain links to third party web sites or services that are not owned or controlled by TAPWAGE INC<br><br>
          <!-- eslint-disable-next-line vue/max-len -->
          TAPWAGE INC has no control over, and assumes no responsibility for the content, privacy policies, or practices of any third party web sites or services. We do not warrant the offerings of any of these entities/individuals or their websites.<br><br>
          <!-- eslint-disable-next-line vue/max-len -->
          You acknowledge and agree that TAPWAGE INC shall not be responsible or liable, directly or indirectly, for any damage or loss caused or alleged to be caused by or in connection with use of or reliance on any such content, goods or services available on or through any such third party web sites or services.<br><br>
          <!-- eslint-disable-next-line vue/max-len -->
          We strongly advise you to read the terms and conditions and privacy policies of any third party web sites or services that you visit.<br><br>

          <b>Termination</b><br>
          <!-- eslint-disable-next-line vue/max-len -->
          We may terminate or suspend your account and bar access to the Service immediately, without prior notice or liability, under our sole discretion, for any reason whatsoever and without limitation, including but not limited to a breach of the Terms.<br><br>

          <!-- eslint-disable-next-line vue/max-len -->
          If you wish to terminate your account, you may simply discontinue using the Service.<br><br>
          <!-- eslint-disable-next-line vue/max-len -->
          All provisions of the Terms which by their nature should survive termination shall survive termination, including, without limitation, ownership provisions, warranty disclaimers, indemnity and limitations of liability.<br><br>

          <b>Indemnification</b><br>
          <!-- eslint-disable-next-line vue/max-len -->
          You agree to defend, indemnify and hold harmless TAPWAGE INC and its licensee and licensors, and their employees, contractors, agents, officers and directors, from and against any and all claims, damages, obligations, losses, liabilities, costs or debt, and expenses (including but not limited to attorney's fees), resulting from or arising out of a) your use and access of the Service, by you or any person using your account and password; b) a breach of these Terms, or c) Content posted on the Service.<br><br>

          <b>Limitation Of Liability</b><br>
          <!-- eslint-disable-next-line vue/max-len -->
          In no event shall TAPWAGE INC, nor its directors, employees, partners, agents, suppliers, or affiliates, be liable for any indirect, incidental, special, consequential or punitive damages, including without limitation, loss of profits, data, use, goodwill, or other intangible losses, resulting from (i) your access to or use of or inability to access or use the Service; (ii) any conduct or content of any third party on the Service; (iii) any content obtained from the Service; and (iv) unauthorized access, use or alteration of your transmissions or content, whether based on warranty, contract, tort (including negligence) or any other legal theory, whether or not we have been informed of the possibility of such damage, and even if a remedy set forth herein is found to have failed of its essential purpose.<br><br>

          <b>Disclaimer</b><br>
          <!-- eslint-disable-next-line vue/max-len -->
          Your use of the Service is at your sole risk. The Service is provided on an “AS IS” and “AS AVAILABLE” basis. The Service is provided without warranties of any kind, whether express or implied, including, but not limited to, implied warranties of merchantability, fitness for a particular purpose, non-infringement or course of performance.<br><br>
          <!-- eslint-disable-next-line vue/max-len -->
          TAPWAGE INC its subsidiaries, affiliates, and its licensors do not warrant that a) the Service will function uninterrupted, secure or available at any particular time or location; b) any errors or defects will be corrected; c) the Service is free of viruses or other harmful components; or d) the results of using the Service will meet your requirements.<br><br>

          <b>Exclusions</b><br>
          <!-- eslint-disable-next-line vue/max-len -->
          Some jurisdictions do not allow the exclusion of certain warranties or the exclusion or limitation of liability for consequential or incidental damages, so the limitations above may not apply to you.<br><br>

          <b>Governing Law</b><br>
          <!-- eslint-disable-next-line vue/max-len -->
          These Terms shall be governed and construed in accordance with the laws of New York, United States, without regard to its conflict of law provisions.<br><br>
          <!-- eslint-disable-next-line vue/max-len -->
          Our failure to enforce any right or provision of these Terms will not be considered a waiver of those rights. If any provision of these Terms is held to be invalid or unenforceable by a court, the remaining provisions of these Terms will remain in effect. These Terms constitute the entire agreement between us regarding our Service, and supersede and replace any prior agreements we might have had between us regarding the Service.<br><br>

          <b>Changes</b><br>
          <!-- eslint-disable-next-line vue/max-len -->
          We reserve the right, at our sole discretion, to modify or replace these Terms at any time. If a revision is material we will provide at least 15 days notice prior to any new terms taking effect. What constitutes a material change will be determined at our sole discretion.<br><br>
          <!-- eslint-disable-next-line vue/max-len -->
          By continuing to access or use our Service after any revisions become effective, you agree to be bound by the revised terms. If you do not agree to the new terms, you are no longer authorized to use the Service.<br><br>

          <b>Contact Us</b><br>
          If you have any questions about these Terms, please contact us.
        </p>
      </div>
      <v-form
        ref="form"
        v-model="valid"
        @submit.prevent="submitForm"
      >
        <DpplCheckbox
          v-model="acceptedTos"
          :label="'I agree to Datapeople\'s Terms of Service'"
          :rules="acceptedTosRules"
          color="brandPrimary"
        />
        <DpplSignupFormButton
          type="submit"
          block
          :loading="loading"
        >
          Accept Terms of Service
        </DpplSignupFormButton>
      </v-form>
    </WizardContent>
  </WizardContainer>
</template>

<script>
import WizardContainer from '@/components/shared/WizardContainer.vue';
import WizardContent from '@/components/shared/WizardContent.vue';
import { signupAcceptTos, signupIsBilling } from '@/api/signup';
import DpplCheckbox from '@/components/datapeople/DpplCheckbox.vue';
import DpplSignupFormButton from '@/components/datapeople/DpplSignupFormButton.vue';
import { mapActions } from 'pinia';
import { useWizard } from '@/stores/wizard/wizard';
import { useAppGate } from '@/stores/app/gate';

export default {
  name: 'TermsOfService',
  components: {
    WizardContainer,
    WizardContent,
    DpplCheckbox,
    DpplSignupFormButton,
  },
  emits: ['track-page-load'],
  data() {
    return {
      acceptedTos: false,
      acceptedTosRules: [(v) => !!v || 'You must agree to terms of service'],
      valid: false,
      loading: false,
    };
  },
  computed: {
    isDatapeopleAnywhere() {
      return this.$route.params.id === 'datapeople-anywhere' || false;
    },
  },
  async created() {
    if (useAppGate().errorPageRoute !== this.$route.name) {
      await this.$router.replace({ name: 'root' });
      return;
    }

    const registerConversion = async () => {
      const responseJSON = await signupIsBilling();
      if (window.gtag) {
        if (responseJSON.success === true && responseJSON.isBilling === false) {
          window.gtag('event', 'conversion', { send_to: 'AW-873652164/WA_vCPa7_tMBEMS_y6AD' });
        } else if (responseJSON.success === true && responseJSON.isBilling === true) {
          window.gtag('event', 'conversion', { send_to: 'AW-873652164/wpRCCJ3L_tMBEMS_y6AD' });
        }
      }
    };

    registerConversion().catch((e) => {
      this.updateFlash({ message: e.message });
      this.loading = false;
    });
  },
  beforeCreate() {
    this.$emit('track-page-load', { page: 'Terms of Service' });
  },
  methods: {
    ...mapActions(useWizard, ['updateFlash']),
    async submitForm() {
      try {
        const formValidateResult = await this.$refs.form.validate();
        if (formValidateResult.valid) {
          this.loading = true;
          const responseJSON = await signupAcceptTos({
            acceptedTos: this.acceptedTos,
          });
          if (responseJSON.success === true) {
            if (this.isDatapeopleAnywhere) {
              this.$router.replace({ name: 'datapeople-anywhere-login-success' });
            } else {
              this.$router.replace({ name: 'root' });
            }
          }
        }
      } catch (e) {
        this.updateFlash({ message: 'Something went wrong' });
        this.loading = false;
      }
    },
  },
};
</script>
<style scoped lang="less">
.terms-header {
  color: @text-brand;
}

hr {
  margin-bottom: 20px;
}
.terms-and-conditions {
  height: 300px;
  overflow-y: scroll;
  text-align: left;
  background-color: @bg-canvas;
  padding: 16px 8px 16px 16px;
  scrollbar-width: thin;
  scrollbar-color: @text-brand @stroke-default;
}

.terms-and-conditions::-webkit-scrollbar {
  width: 8px;
}

.terms-and-conditions::-webkit-scrollbar-track {
  background: @bg-canvas;        /* color of the tracking area */
}

.terms-and-conditions::-webkit-scrollbar-thumb {
  background-color: @text-brand;
  border-radius: 10px;
}
.v-input :deep(.v-input__slot) {
  margin-bottom: 2px;
}
.v-input :deep(.v-messages) {
  margin-bottom: 6px;
}
</style>
